(function() {
	'use strict';

	angular.module('pharmaPortalApp').controller('ReportDialogController', ReportDialogController);

	ReportDialogController.$inject = [ '$uibModalInstance', '$timeout', '$scope', '$stateParams', 'DataUtils', 'entity', '$state', 'Report', 'ModuleSettings','ReportGroup' ];

	function ReportDialogController($uibModalInstance, $timeout, $scope, $stateParams, DataUtils, entity, $state, Report, ModuleSettings, ReportGroup) {
		var vm = this;

		vm.report = entity;
		vm.byteSize = DataUtils.byteSize;
		vm.openFile = DataUtils.openFile;

		vm.reportGroups = [];

		vm.clear = clear;
		vm.save = save;
		vm.loadAll = loadAll;
		vm.nameForLink = "";

		$timeout(function() {
			angular.element('.form-group:eq(1)>input').focus();
		});

		vm.setThumbnail = function($file, report) {
			if ($file && $file.$error === 'pattern') {
				return;
			}
			if ($file) {
				DataUtils.toBase64($file, function(base64Data) {
					$scope.$apply(function() {
						report.thumbnail = base64Data;
						report.thumbnailContentType = $file.type;
					});
				});
			}
		};

		function clear() {
			$uibModalInstance.dismiss('cancel');
		}

		function save() {
			vm.isSaving = true;
			if (vm.report.id !== null) {
				Report.update(vm.report, onSaveSuccess, onSaveError);
			} else {
				Report.save(vm.report, onSaveSuccess, onSaveError);
			}
		}

		function onSaveSuccess(result) {
			$uibModalInstance.close(result);
			vm.isSaving = false;
		}

		function onSaveError() {
			vm.isSaving = false;
		}

		function loadAll() {
		    vm.report.reportGroup = {};
            ReportGroup.query(function (result) {
                vm.reportGroups = result;
                angular.forEach(vm.reportGroups,function (x,y){
                    if (x.name===vm.report.reportGroupLabel) {
                        vm.report.reportGroup = x;
                    }
                });
            }, function (error) {
            });

			vm.moduleSettings = ModuleSettings.query();
			vm.moduleSettings.$promise.then(function(result) {
				vm.moduleSettings = result;

				if (!vm.moduleSettings.queriesModule) {
					$state.go('accessdenied');
				}
			});
		}
		loadAll();
	}
})();
